import { render } from "./selectFabricante.vue?vue&type=template&id=ed40898e"
import script from "./selectFabricante.vue?vue&type=script&lang=ts"
export * from "./selectFabricante.vue?vue&type=script&lang=ts"
script.render = render

export default script